module.exports = __webpack_public_path__ + "44161f6f02f9a6d9f07d572c137421f0.png";